module.exports = __webpack_public_path__ + "img/076-philosopher.48aed412.png";